import React, { useEffect, useState } from "react";
import TWSCautionInsertion from "./TWSCautionInsertion";
import TWSCautionUpdate from "./TWSCautionUpdate";
import axios from "axios";
import TWSCautionCancel from "./TWSCautionCancel";

const TWSCautionMaster = () => {
  const [active, setActive] = useState("insert");
  const [sectionData, setSectionData] = useState([]);
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const sec = [...new Set(sectionData.map((o) => o.section))];
  const stn = [...new Set(sectionData.map((o) => o.station))];

  const fetchSection = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlBlockPrefix}getstationcode`);
      if (response.data.status === "ok") {
        const fetchedData = response.data.data;

        setSectionData(fetchedData);
      }
      setLoading(false);
    } catch (err) {
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSection();
  }, []);

  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <div className="text-center  p-3 mt-5 fw-bold papaDiv">
        <h5 className="">TWS CAUTION </h5>
      </div>
      <div className="row m-5">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("insert");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "insert" && "active"
            }`}
          >
            Insert
          </button>
          <button
            onClick={() => {
              setActive("update");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "update" && "active"
            }`}
          >
            Update
          </button>{" "}
          <button
            onClick={() => {
              setActive("cancel");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "cancel" && "active"
            }`}
          >
            cancel
          </button>
          <hr />
        </div>
      </div>
      <div className="row">
        {active === "insert" ? (
          <div className="">
            <TWSCautionInsertion sec={sec} stn={stn} />
          </div>
        ) : active === "cancel" ? (
          <div className="">
            <TWSCautionCancel sec={sec} stn={stn} />
          </div>
        ) : (
          <div className="">
            <TWSCautionUpdate sec={sec} stn={stn} />
          </div>
        )}
      </div>
    </div>
  );
};
export default TWSCautionMaster;
